import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { AccountService } from './account.service';

@Injectable()
export class AuthGuardService extends KeycloakAuthGuard {

  constructor(protected router: Router,
    protected keycloakAngular: KeycloakService,
    protected accountService: AccountService) {
    super(router, keycloakAngular);
  }

  isAccessAllowed(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      if (!this.authenticated) {
        this.keycloakAngular.login();
        return;
      }

      if (!this.accountService.isMaintainer()) {
        this.router.navigate(['/unauthorized']);
        this.authenticated = false;
        resolve(false);
      } else {
        resolve(true);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth-guard.service.ts